import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import EmployeesInformationsBasic from "@icoach/employees/informations/EmployeesInformationsBasic";
import EmployeesInformationsClockIn from "@icoach/employees/informations/EmployeesInformationsClockIn";
import { Typography, Card, Tabs, Tab, Button, Box } from "@curves/ui-base";
import { HUMAN_RESOURCES_EMPLOYEES_OVERVIEW } from "@icoach/router/routerPath";
import { isEqual } from "@util/utils";

const EmployeesInformationsPage = React.forwardRef((props, ref) => {
	const { employeeID } = useParams();
	const history = useHistory();
	const [tabsIndex, setTabsIndex] = useState("information");

	const handleTabChange = (e, value) => {
		setTabsIndex(value);
	};

	const handleRedirectClick = () => {
		history.push(HUMAN_RESOURCES_EMPLOYEES_OVERVIEW);
	};

	useEffect(
		() => {
			if (!/^[\d]+$/.test(employeeID)) {
				return;
			}
		},
		// eslint-disable-next-line
		[]
	);

	return (
		<Box className="container main-container-spacing">
			<Box component="header" className="page-header">
				<Typography className="page-header-title" variant="h3">
					員工資訊
				</Typography>
				<Box className="btn-group">
					<Button variant="contained" onClick={handleRedirectClick}>
						返回員工總覽
					</Button>
				</Box>
			</Box>
			<Card className="tabs-content-layout">
				<Box component="header" className="page-header">
					<Tabs value={tabsIndex} onChange={handleTabChange}>
						<Tab label="基本資料" value="information" />
						<Tab label="出勤紀錄" value="clockIn" />
					</Tabs>
				</Box>
				{isEqual(tabsIndex, "information") ? <EmployeesInformationsBasic employeeID={employeeID} /> : null}
				{isEqual(tabsIndex, "clockIn") ? <EmployeesInformationsClockIn employeeID={employeeID} /> : null}
			</Card>
		</Box>
	);
});

export default EmployeesInformationsPage;
